const cookiePreferenceNames = ['essential', 'analytics', 'personalisation'] as const

type CookiePreferenceName = typeof cookiePreferenceNames[number]

interface CookiePreferenceOption {
  name: CookiePreferenceName;
  isNecessary: boolean;
}

type CookiePreferences = Record<string, boolean> | Record<string, never>

interface CookiePreferenceConfig extends Record<CookiePreferenceName, CookiePreferenceOption> {}

const cookiePreference: CookiePreferenceConfig = {
  essential: {
    name: 'essential',
    isNecessary: true
  },
  analytics: {
    name: 'analytics',
    isNecessary: false
  },
  personalisation: {
    name: 'personalisation',
    isNecessary: false
  }
} as const

export { cookiePreferenceNames, cookiePreference }

export type {
  CookiePreferenceName,
  CookiePreferenceConfig,
  CookiePreferenceOption,
  CookiePreferences
}
